export const useRequestConverter = () => {
  const toUserInfoByState = (store) => {
    return JSON.stringify({
      name: store.state.advanceInterview.name,
      kana: store.state.advanceInterview.kana,
      age: store.state.advanceInterview.age,
      otherAge: store.state.advanceInterview.otherAge,
      nameOfParent: store.state.advanceInterview.nameOfParent,
      telOfParent: store.state.advanceInterview.telOfParent,
      certificates: store.state.advanceInterview.certificates,
    })
  }
  const toRiskOfSeriousByState = (store) => {
    const hasDuringTreatment = store.state.advanceInterview.hasDuringTreatment

    return JSON.stringify({
      hasDuringTreatment: hasDuringTreatment,
      riskOfSerious: hasDuringTreatment === '有' ? store.state.advanceInterview.riskOfSerious : [],
      riskOfSeriousOther: hasDuringTreatment === '有' ? store.state.advanceInterview.riskOfSeriousOther: [],
      obesityRisk: store.state.advanceInterview.obesityRisk,
      pregnancyRisk: store.state.advanceInterview.pregnancyRisk,
      smokingRisk: store.state.advanceInterview.smokingRisk,
      otherRisk: store.state.advanceInterview.otherRisk,
    })
  }
  const toMedicalInterviewByState = (store) => {
    const vaccinationHistory = store.state.advanceInterview.vaccinationHistory
    const symptoms = store.state.advanceInterview.symptoms

    return JSON.stringify({
      inspectionDate: store.state.advanceInterview.inspectionDate,
      kitName: store.state.advanceInterview.kitName,
      searchMethod: store.state.advanceInterview.searchMethod,
      searchOtherMethod: store.state.advanceInterview.searchOtherMethod,
      vaccinationHistory: vaccinationHistory,
      coronaVaccinationDate: vaccinationHistory !== '0回' && vaccinationHistory !== '不明' ? store.state.advanceInterview.coronaVaccinationDate : '',
      coronaVaccineName: store.state.advanceInterview.coronaVaccineName,
      fluVaccinationHistory: store.state.advanceInterview.fluVaccinationHistory,
      symptoms: symptoms,
      dateOfOnset: symptoms === '有' ? store.state.advanceInterview.dateOfOnset : '',
      fever: symptoms === '有' ? store.state.advanceInterview.fever : '',
      feverNum: symptoms === '有' ? store.state.advanceInterview.feverNum: '',
      cough: symptoms === '有' ? store.state.advanceInterview.cough: '',
      otherThanCough: symptoms === '有' ? store.state.advanceInterview.otherThanCough : '',
      headache: symptoms === '有' ? store.state.advanceInterview.headache : '',
      senseOfFatigue: symptoms === '有' ? store.state.advanceInterview.senseOfFatigue : '',
      nausea: symptoms === '有' ? store.state.advanceInterview.nausea : '',
      diarrhea: symptoms === '有' ? store.state.advanceInterview.diarrhea : '',
      conjunctivitis: symptoms === '有' ? store.state.advanceInterview.conjunctivitis : '',
      pharyngitis: symptoms === '有' ? store.state.advanceInterview.pharyngitis: ''
    })
  }
  const toTravelHistoryByState = (store) => {
    return JSON.stringify({
      travelHistory: store.state.advanceInterview.travelHistory,
      departureDate: store.state.advanceInterview.departureDate,
      entryDate: store.state.advanceInterview.entryDate,
      destination: store.state.advanceInterview.destination,
    })
  }
  const toIntensiveContactByState = (store) => {
    return JSON.stringify({
      fulPatientContact: store.state.advanceInterview.fulPatientContact,
      coronaPatientContact: store.state.advanceInterview.coronaPatientContact,
      hasIntensiveContact: store.state.advanceInterview.hasIntensiveContact,
      causeIntensiveContact: store.state.advanceInterview.causeIntensiveContact,
      causeIntensiveContactOther: store.state.advanceInterview.causeIntensiveContactOther,
      placeIntensiveContact: store.state.advanceInterview.placeIntensiveContact,
      placeIntensiveContactOther: store.state.advanceInterview.placeIntensiveContactOther,
    })
  }
  const toRecordTimeByState = (store) => {
    return JSON.stringify({
      doctorName: store.state.medicalRecord.doctorName,
      implementationDate: store.state.medicalRecord.implementationDate,
      startTime: store.state.medicalRecord.startTime,
      endTime: store.state.medicalRecord.endTime
    })
  }
  const toRecordConsultationByState = (store) => {
    return JSON.stringify({
      mainSymptom: store.state.medicalRecord.mainSymptom,
      cough: store.state.medicalRecord.cough,
      shortnessOfBreath: store.state.medicalRecord.shortnessOfBreath,
      pharyngitis: store.state.medicalRecord.pharyngitis,
      senseOfFatigue: store.state.medicalRecord.senseOfFatigue,
      gastrointestinal: store.state.medicalRecord.gastrointestinal,
      dehydration: store.state.medicalRecord.dehydration
    })
  }
  const toRecordAssessmentByState = (store) => {
    return JSON.stringify({
      diagnostic: store.state.medicalRecord.diagnostic,
      diagnosticOther: store.state.medicalRecord.diagnosticOther,
      finding: store.state.medicalRecord.finding,
    })
  }
  const toRecordPlanByState = (store) => {
    return JSON.stringify({
      plan: store.state.medicalRecord.plan,
      planOther: store.state.medicalRecord.planOther,
      prescription: store.state.medicalRecord.prescription
    })
  }

  const toPayload = (store) => {
    return {
      userInfo: toUserInfoByState(store),
      riskOfSerious: toRiskOfSeriousByState(store),
      interview: toMedicalInterviewByState(store),
      travelHistory: toTravelHistoryByState(store),
      intensiveContact:  toIntensiveContactByState(store),
      recordTime: toRecordTimeByState(store),
      recordConsultation: toRecordConsultationByState(store),
      recordAssessment: toRecordAssessmentByState(store),
      recordPlan: toRecordPlanByState(store)
    }
  }
  return {
    toUserInfoByState,
    toRiskOfSeriousByState,
    toMedicalInterviewByState,
    toTravelHistoryByState,
    toIntensiveContactByState,
    toRecordTimeByState,
    toRecordConsultationByState,
    toRecordAssessmentByState,
    toRecordPlanByState,
    toPayload
  }
}
